<template>
  <div class="container-fluid">
    <div class="d-flex align-items-center">
      <h2 class="page-heading mr-auto"><back-button to="/orders/equipment"/>Новая заявка</h2>
      <btn-action :disabled="selectedTechnician === null" class="btn btn-primary" @click="save">Оформить заявку</btn-action>
    </div>
    <div class="card mb-3">
      <h3 class="card-header"><span class="text-caps">Пользователь</span></h3>
      <div class="card-body" style="max-width: 28rem;">
        <server-select
          v-model="selectedTechnician"
          :custom-label="fullName"
          endpoint="users_by_role"
          :endpoint-params="{role: ['tech']}"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <h3 class="card-header"><span class="text-caps">Оборудование</span></h3>
          <div class="card-body">
            <v-multiselect v-if="equipments" :options="equipments" v-model="selectedEquipment" label="name" placeholder="Выберите..."/>
            <table class="table table-sm px-0 mt-2 mb-0" v-if="selectedEquipments && selectedEquipments.length">
              <tr v-for="(equipment, index) in selectedEquipments">
                <td style="vertical-align: middle;"><strong>{{equipment.data.name}}</strong></td>
                <td style="vertical-align: middle;" width="1">
                  <div class="input-group input-group-sm" style="width: 8em;">
                    <input type="number" class="form-control" v-model="equipment.count" min="0">
                    <div class="input-group-append"><span class="input-group-text">{{equipment.data.measure}}</span></div>
                    <div class="input-group-append"><button class="btn btn-outline-danger" @click="deleteEquipment(index)">&times;</button></div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <h3 class="card-header"><span class="text-caps">Детали</span></h3>
          <div class="card-body">
            <v-multiselect v-if="details" :options="details" v-model="selectedDetail" label="name" placeholder="Выберите..."/>
            <table class="table table-sm px-0 mt-2 mb-0" v-if="selectedDetails && selectedDetails.length">
              <tr v-for="(detail, index) in selectedDetails">
                <td style="vertical-align: middle;"><strong>{{detail.data.name}}</strong></td>
                <td style="vertical-align: middle;" width="1">
                  <div class="input-group input-group-sm" style="width: 8em;">
                    <input type="number" class="form-control" v-model="detail.count" min="0">
                    <div class="input-group-append"><span class="input-group-text">{{detail.data.measure}}</span></div>
                    <div class="input-group-append"><button class="btn btn-outline-danger" @click="deleteDetail(index)">&times;</button></div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import filters from '../../../filters'

  export default {
    metaInfo: {title: 'Новая заявка на детали и оборудование'},
    data () {
      return {
        selectedEquipment: null,
        selectedDetail: null,
        selectedEquipments: [],
        selectedDetails: [],
        selectedTechnician: null,
      }
    },
    methods: {
      fullName: filters.fullName,
      deleteEquipment (index) {
        this.equipments.push(this.selectedEquipments[index].data)
        this.selectedEquipments.splice(index, 1)
      },
      deleteDetail (index) {
        this.details.push(this.selectedDetails[index].data)
        this.selectedDetails.splice(index, 1)
      },
      save () {
        return api.post('orders/details', {
          user_id: this.selectedTechnician.id,
          parts_request: this.selectedDetails.map(current => ({
            amount: current.count,
            part_id: current.data.id,
          })),
          extra_parts_request: this.selectedEquipments.map(current => ({
            amount: current.count,
            extra_part_id: current.data.id,
          })),
        }).then(() => {
          this.$router.push('/orders/equipment')
        })
      },
    },
    watch: {
      selectedEquipment (value) {
        if (value) {
          this.selectedEquipments.push({
            count: 1,
            data: value,
          })
          this.equipments.splice(this.equipments.indexOf(value), 1)
          this.selectedEquipment = null
        }
      },
      selectedDetail (value) {
        if (value) {
          this.selectedDetails.push({
            count: 1,
            data: value,
          })
          this.details.splice(this.details.indexOf(value), 1)
          this.selectedDetail = null
        }
      },
    },
    asyncComputed: {
      equipments () {
        return api
          .get(`parts`)
          .then(({data}) => data.data)
      },
      details () {
        return api
          .get(`details`)
          .then(({data}) => data.data)
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/orders/equipment/create.vue